export default __webpack_public_path__ + "static/media/logo_bap.ffd1411e.png";